import { render, staticRenderFns } from "./AddEditPotentialInstructor.vue?vue&type=template&id=26232874&scoped=true"
import script from "./AddEditPotentialInstructor.vue?vue&type=script&lang=js"
export * from "./AddEditPotentialInstructor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26232874",
  null
  
)

export default component.exports